import React from 'react';
import { IconProps } from '.';

const SvgMove = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M16 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2 19a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM16 19a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z'
      />
    </svg>
  );
};

export default SvgMove;
